import { Container, Typography } from "@mui/material";
import { useContext, useEffect,useState } from "react";
import { useParams } from "react-router-dom";

export const FormScopusPage: React.FC<{}> = () =>{
    const { obj } = useParams();
    const objeto = JSON.parse(obj || '');
    
    return(
        <Container sx={{mt:2, mb:4}}>
            <Typography variant="h4" gutterBottom>
                Importar de Scopus
            </Typography>
        </Container>
    );
}